<template>
  <el-container class="page-x" direction="vertical">
    <div class="search-x">
      <div class="search-item" style="margin-left: 0">
        <span class="label">用户信息</span>
        <el-input
          class="input-box"
          clearable
          placeholder="用户ID、姓名、手机号、证件号"
          v-model.trim="searchBox.keyword"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">印刷号</span>
        <el-input
          class="input-box"
          placeholder="印刷号"
          clearable
          v-model.trim="searchBox.likePrintNo"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">体检来源</span>
        <el-select
          v-model="searchBox.source"
          @change="changeReportSource"
          class="input-box"
          clearable
        >
          <el-option
            v-for="item in physicalSource"
            :value="item.value"
            :key="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">报告来源</span>
        <el-select v-model="searchBox.reportSource" class="input-box" clearable>
          <el-option
            v-for="item in reportSourceList"
            :value="item.value"
            :key="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">接收报告时间</span>
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          @change="toChangeTime"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          }"
        >
        </el-date-picker>
      </div>
      <!--添加权限码-->
      <!--v-auth="'sw_operate_log_index'"-->
      <el-button v-auth="'sa_exam_report_page'" type="primary" @click="toSearch"
        >查询</el-button
      >
      <el-button
        v-auth="'sa_item_page'"
        type="primary"
        @click="() => ($root.showPage = false)"
        >重置</el-button
      >
    </div>
    <div class="cont-x" ref="tableBox">
      <div class="table-x">
        <el-table
          v-loading="loading"
          :data="tableData"
          :height="tableHeight"
          border
          class="mb20"
        >
          <el-table-column type="index" align="center" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="userId" align="center" label="用户ID">
          </el-table-column>
          <el-table-column prop="name" align="center" label="用户姓名">
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="手机号">
          </el-table-column>
          <el-table-column prop="cardNo" align="center" label="证件号">
          </el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单号">
          </el-table-column>
          <el-table-column
            prop="printNo"
            align="center"
            width="120"
            label="印刷号"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            width="120"
            label="报告接收时间"
          >
          </el-table-column>
          <el-table-column
            prop="reportSourceName"
            align="center"
            label="报告来源"
          >
          </el-table-column>
          <el-table-column prop="source" align="center" label="体检来源">
            <template slot-scope="scope">
              <span>{{ scope.row.source | filterValue(physicalSource) }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="middle"
                v-auth="'sa_exam_detail_ocr'"
                class="mb10"
                type="text"
                @click="toDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchBox.pageNo"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100]"
          :page-size="searchBox.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
  </el-container>
</template>
<script>
const _sourceList = [
  { label: "爱康", id: "AIKANG" },
  { label: "其他", id: "MJK" },
];
const _physicalSource = [
  { label: "核保体检", value: 1 },
  { label: "健康体检", value: 2 },
  { label: "手动上传", value: 3 },
  { label: "官微", value: 4 },
  { label: "企微", value: 5 },
];
import { isArray, dateFormat } from "@/assets/js/until.js";
export default {
  data() {
    return {
      loading: false,
      // 查询条件
      timeRange: [],
      tableHeight: 0,
      searchBox: {
        pageSize: 10,
        pageNo: 1,
        keyword: "", // 关键字（用户ID,姓名、手机号、证件号）
        likePrintNo: "", // 印刷号
        reportSource: "", // 报告来源
        startDate: "", // 开始日期
        endDate: "", // 结束日期
      },
      sourceList: _sourceList,
      physicalSource: _physicalSource,
      reportSourceList: [],
      tableData: [],
      total: 0,
    };
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "体检报告", link: "" },
      { name: "体检报告查询", link: "" },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.listenWindow();
      this.getData();
    });
  },
  filters: {
    filterValue(text, data) {
      return (
        data.find((item) => {
          if (text == item.value) {
            return item;
          }
        })?.label || text
      );
    },
  },
  methods: {
    //窗口改变，重新取得高度
    listenWindow() {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      window.addEventListener("resize", () => {
        clearTimeout(this.resizeFlag);
        this.resizeFlag = setTimeout(() => {
          this.tableHeight = this.$refs.tableBox.offsetHeight;
        }, 300);
      });
    },
    num2Text(id, keyName) {
      if (this[keyName] && isArray(this[keyName])) {
        let findItem = this[keyName].find((o) => o.id === id);
        if (findItem) return findItem["label"];
        else return "";
      } else {
        return "";
      }
    },
    toChangeTime(val) {
      if (val) {
        this.searchBox.startDate = dateFormat(val[0]);
        this.searchBox.endDate = dateFormat(val[1]);
      } else {
        this.searchBox.startDate = "";
        this.searchBox.endDate = "";
      }
    },
    toSearch() {
      this.searchBox.pageNo = 1;
      this.getData();
    },
    getData() {
      let apiName = "examReportPage";
      let data = { ...this.searchBox };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { code, msg, data } = res;
          if (code === 1) {
            this.total = data.total;
            this.tableData = data.data || [];
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.searchBox.pageNo = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
    toDetail(item) {
      if (item.reportSource == "KONG") item.reportSource = "MJK";
      if (item.reportSource) {
        let query = {
          id: item.bookingId,
          orderNo: item.orderNo,
          reportSource: item.reportSource,
          source: item.source,
        };
        this.$router.push({
          name: "ReportDetail",
          query,
        });
      } else {
        this.$message({
          type: "warning",
          message: "暂不支持此类型报告",
        });
      }
    },
    changeReportSource(type) {
      this.searchBox.reportSource = "";
      this.reportSourceList = [];
      this.getSourceList(type);
    },
    getSourceList(type) {
      let apiName = "reportSourceList";
      let data = { source: type };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { code, msg, data } = res;
          console.log(data);
          if (code === 1) {
            var arr = [];
            for (let i in data) {
              let item = data[i];
              for (let j in item) {
                arr.push({
                  value: j,
                  label: item[j],
                });
              }
            }
            console.log(arr);
            this.reportSourceList = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name != "ReportDetail") {
      next((vm) => {
        vm.$root.breadList = [
          { name: "体检报告", link: "" },
          { name: "体检报告查询", link: "" },
        ];
        vm.searchBox = {
          pageSize: 10,
          pageNo: 1,
          keyword: "", // 关键字（用户ID,姓名、手机号、证件号）
          likePrintNo: "", // 印刷号
          reportSource: "", // 报告来源
          startDate: "", // 开始日期
          endDate: "", // 结束日期
        };
        vm.$nextTick(() => {
          vm.listenWindow();
          vm.getData();
        });
      });
    } else {
      next((vm) => {
        vm.$root.breadList = [
          { name: "体检报告", link: "" },
          { name: "体检报告查询", link: "" },
        ];
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "ReportDetail") {
      this.searchBox = {
        pageSize: 10,
        pageNo: 1,
        keyword: "", // 关键字（用户ID,姓名、手机号、证件号）
        likePrintNo: "", // 印刷号
        reportSource: "", // 报告来源
        startDate: "", // 开始日期
        endDate: "", // 结束日期
      };
      this.getData();
      to.meta.keepAlive = false;
    }

    next(true);
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.search-x {
  flex-shrink: 0;
  .search-item {
    span {
      display: inline-block;
      text-align: right;
    }
  }
}
.cont-x {
  flex: 1;
  flex-shrink: 0;
  .table-x {
    height: 100%;
  }
}
</style>
